"use client";
import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef } from "react";
import { cardsRecipe } from "./cards.css.js";
import { LoadingSkeleton } from "./SharedComponents.js";
const InfoCard = forwardRef(function InfoCard2({ isLoading, transparent, density, ...props }, ref) {
  return jsx("div", { ref, ...props, className: classNames(props.className, cardsRecipe({
    type: "info",
    isLoading,
    transparent,
    density
  })), children: isLoading ? jsx(LoadingSkeleton, {}) : props.children });
});
export {
  InfoCard
};
